import React, { useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import CardsHeader from './components/CardsHeader';
import TeamSelector from './components/TeamSelector';
import DashboardCards from './components/DashboardCards';
import PerformanceTable from './components/PerformanceTable';
import dayjs from 'dayjs';
import MonthlyWiseGlobalFilter from '../TeamWiseAnalytics/MonthlyWiseGlobalFilter';

const SogoMilestoneLanding = () => {
  const [sogoFromDate, setsogoFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [sogoToDate, setSogoToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [sogoSelectedTeam, sogoSetSelectedTeam] = useState({ id: -1, value: 'All' });

  return (
    <GlobalWrapper title={'SOGO Milestone'}>
      <MonthlyWiseGlobalFilter
        fromDate={sogoFromDate}
        setFromDate={setsogoFromDate}
        toDate={sogoToDate}
        setToDate={setSogoToDate}
        setSelectedTeam={sogoSetSelectedTeam}
        selectedTeam={sogoSelectedTeam}
      />
      <CardsHeader
        fromDate={sogoFromDate}
        setFromDate={setsogoFromDate}
        toDate={sogoToDate}
        setToDate={setSogoToDate}
        selectedTeam={sogoSelectedTeam}
      />
      {/* <TeamSelector /> */}
      <DashboardCards
        fromDate={sogoFromDate}
        setFromDate={setsogoFromDate}
        toDate={sogoToDate}
        setToDate={setSogoToDate}
        selectedTeam={sogoSelectedTeam}
      />
      <PerformanceTable
        fromDate={sogoFromDate}
        setFromDate={setsogoFromDate}
        toDate={sogoToDate}
        setToDate={setSogoToDate}
        selectedTeam={sogoSelectedTeam}
      />
    </GlobalWrapper>
  );
};

export default SogoMilestoneLanding;
